<template>
  <div class="kk__goto--cell">
    <div class="kk__goto--cell-header">
      <input
        ref="cell"
        v-model="inputValue"
        class="kk__goto--cell-input"
        placeholder="e.g. F3 or D5:G9"
        @keydown="keyDown"
        @keyup="handleKeyUP"
      />
    </div>

    <div class="kk__goto--cell-body">
      <customtable
        :headers="headers"
        :data="gotoCellData"
        :head-style="headStyle"
        :td-bg="bgOnHover"
        :parent-scope="parentScope"
        @handleTab="handleTabNavigation"
      />
    </div>
  </div>
</template>

<script>
import { HotkeyScopes, gotoType } from "../../../utils/constants";
import DesignerMixin from "../DesignerMixin";
import hotkeys from "hotkeys-js";
import Customtable from "../../commons/Customtable.vue";

export default {
  components: { Customtable },
  mixins: [DesignerMixin],
  emits: ["navigate", "hide"],

  data() {
    return {
      parentScope: HotkeyScopes.goto.search,
      inputValue: "",
      disabled: true,
      prevScope: null,
      keyPressed: null,
      headers: [
        { label: this.$t("goTo.gotocell.name"), accessor: "name", icon: "icon-menu-down" },
        { label: this.$t("goTo.gotocell.scope"), accessor: "scope", icon: "icon-menu-down" },
        { label: this.$t("goTo.gotocell.referTo"), accessor: "refer", icon: "icon-menu-down" },
      ],
      gotoCellData: [
        {
          name: { value: "ABCLanguage" },
          scope: { value: "{“KX”/””/””/””/””..." },
          refer: { value: "=ABC!$B$4:$F$11" },
        },
        {
          name: { value: "ABCLayout" },
          scope: { value: "{“KX”/””/””/””/””..." },
          refer: { value: "=ABC!$B$4:$F$11" },
        },
        {
          name: { value: "ABCLanguage" },
          scope: { value: "{“KX”/””/””/””/””..." },
          refer: { value: "=ABC!$B$4:$F$11" },
        },
        {
          name: { value: "ABCLayout" },
          scope: { value: "{“KX”/””/””/””/””..." },
          refer: { value: "=ABC!$B$4:$F$11" },
        },
        {
          name: { value: "ABCLanguage" },
          scope: { value: "{“KX”/””/””/””/””..." },
          refer: { value: "=ABC!$B$4:$F$11" },
        },
        {
          name: { value: "ABCLayout" },
          scope: { value: "{“KX”/””/””/””/””..." },
          refer: { value: "=ABC!$B$4:$F$11" },
        },
        {
          name: { value: "ABCLanguage" },
          scope: { value: "{“KX”/””/””/””/””..." },
          refer: { value: "=ABC!$B$4:$F$11" },
        },
        {
          name: { value: "ABCLayout" },
          scope: { value: "{“KX”/””/””/””/””..." },
          refer: { value: "=ABC!$B$4:$F$11" },
        },
        {
          name: { value: "ABCLanguage" },
          scope: { value: "{“KX”/””/””/””/””..." },
          refer: { value: "=ABC!$B$4:$F$11" },
        },
        {
          name: { value: "ABCLayout" },
          scope: { value: "{“KX”/””/””/””/””..." },
          refer: { value: "=ABC!$B$4:$F$11" },
        },
      ],
      currentFocusIndex: null,
    };
  },

  computed: {
    bgOnHover() {
      return { backgroundColor: "#d3e3f9" };
    },
    headStyle() {
      return { backgroundColor: "#fdfeff" };
    },
    getCurrentComponentScope() {
      return hotkeys.getScope();
    },
  },

  mounted() {
    this.$refs.cell.focus();
    this.prevScope = hotkeys.getScope();
    this.$store.dispatch("setScope", HotkeyScopes.goto.search);
    hotkeys("escape", HotkeyScopes.goto.search, () => {
      this.$emit("hide");
    });

    hotkeys("*", HotkeyScopes.goto.search, (event, handler) => {
      event.preventDefault();

      if (event.code === "Tab") {
        event.preventDefault();
        this.handleTabNavigation(event.shiftKey);
      }

      const isNumKey = event.code.startsWith("Numpad") || event.code.startsWith("Digit");
      if (!isNumKey) return;

      if (this.keyPressed === null) return (this.keyPressed = event.key);
      const shortCut = this.keyPressed + event.key;
      if (shortCut === "02") {
        return this.$emit("navigate", gotoType.special);
      }
      // reset values.
      this.keyPressed = null;
    });
  },
  methods: {
    handleTabNavigation(isShift = false) {
      const focusable = this.getFocusableElements();
      this.currentFocusIndex = (this.currentFocusIndex + (isShift ? -1 : 1) + focusable.length) % focusable.length;
      this.handleFocus(this.currentFocusIndex);
    },

    getFocusableElements() {
      // Collect all focusable elements in the form
      return [...this.$el.querySelectorAll('input, div[tabindex="0"]')].filter(
        (el) => !el.disabled && !el.hasAttribute("disabled")
      );
    },

    handleFocus(index) {
      const focusable = this.getFocusableElements();
      if (index < 0) {
        const activeIndex = focusable.indexOf(document.activeElement);
        if (activeIndex !== -1) this.currentFocusIndex = activeIndex;
        focusable[this.currentFocusIndex].focus();
      } else {
        focusable[index].focus();
      }
    },
    keyDown(event) {
      if (event.key === "Escape") {
        this.$emit("hide");
        return;
      }
    },
    handleKeyUP(event) {
      this.$emit("passKeyUp", this.inputValue, event);
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/styles/variables.less";

.kk__goto--cell {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border: none;
  outline: none;

  &-header {
    width: 90%;
  }

  &-input {
    width: 100%;
    border: 1px solid rgba(8, 50, 119, 0.13);
    border-radius: 3px;
    padding: 7px 10px;
    &:focus-within {
      border: 1px solid @kk-color-royal-blue;
    }
  }

  &-body {
    overflow: auto;
    flex: 1;
  }

  &-input {
    color: @kk-color-primary-blue;
    flex: 1;
  }
}
</style>
